import { Text } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';

export function ErrorPageVwView(): ReactElement {
  return <Text>O-ops, something went wrong! Please contact administrator.</Text>;
}
